import React from 'react';
import { Divider, Typography } from '@mui/material';
import { useTranslation } from 'i18n';
import ResponsiveGrid from 'components/common/ResponsiveGrid';
import OrderItem from './OrderItem';

interface IProps {
  itemType: string;
  currency: string;
  disabled?: boolean;
  orderEntities: any[];
  orderItemsCounts: Record<number, number>;
  onAddOrderItem: (id: number, order: number, hasQuestions: boolean, count?: number) => void;
  onRemoveOrderItem: (id: number) => void;
  maxAmountReached: boolean;
}

const OrderItems: React.FC<React.PropsWithChildren<IProps>> = ({
  itemType,
  disabled,
  currency,
  orderEntities,
  orderItemsCounts,
  onAddOrderItem,
  onRemoveOrderItem,
  maxAmountReached,
}) => {
  const [t] = useTranslation('public');

  if (orderEntities.length === 0 && itemType === 'addon') return null;
  return (
    <ResponsiveGrid container xsSpacing={3} mdSpacing={4}>
      <ResponsiveGrid item>
        <Typography variant="h4">{t(`common:general.orderItem_${itemType}_plural`)}</Typography>
      </ResponsiveGrid>
      <ResponsiveGrid item container direction="column">
        {orderEntities.map((orderEntity, index, { length }) => {
          const { id } = orderEntity;
          return (
            <div key={String(id)}>
              <ResponsiveGrid style={{ padding: '12px 0' }} item>
                <OrderItem
                  disabled={disabled}
                  itemType={itemType}
                  currency={currency}
                  orderEntity={orderEntity}
                  count={orderItemsCounts[id]}
                  onAddOrderItem={(itemId: number, count = 1) =>
                    onAddOrderItem(itemId, index, orderEntity.questions.length > 0, count)
                  }
                  onRemoveOrderItem={onRemoveOrderItem}
                  maxAmountReached={maxAmountReached}
                />
              </ResponsiveGrid>
              {!(itemType === 'addon' && index === length - 1) && (
                <ResponsiveGrid style={{ padding: '12px 0' }} item>
                  <Divider light />
                </ResponsiveGrid>
              )}
            </div>
          );
        })}
      </ResponsiveGrid>
    </ResponsiveGrid>
  );
};

export default OrderItems;
